import { RootState } from "../../../../index";

export const labelListingData = (state: RootState) => state?.chatlabel?.data?.allLabelListingData
export const labelListingDataCount = (state: RootState) => state?.chatlabel?.data?.allLabelListingCount
export const chatLabel = (state: RootState) => state?.chatlabel?.data?.getLabelData
export const updatedLabelData = (state: RootState) => state?.chatlabel?.data?.updateLabelData;
export const deletedLabelData = (state: RootState) => state?.chatlabel?.data?.deletedLabelData;